// extracted by mini-css-extract-plugin
module.exports = {"titleInput":"card-rename-input_titleInput_3Lg"};